import { Button } from '@crm/ui';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BILLING_ROUTES } from '@/modules/billing/constants';

export function UnitHeader({ title, description }: { title: string; description?: string }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="font-medium">{title}</p>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>

      <Button asChild variant="ghost">
        <Link to={BILLING_ROUTES.LINES}>
          <ArrowLeft className="h-4 w-4" />
          Linhas
        </Link>
      </Button>
    </div>
  );
}
